import { render, staticRenderFns } from "./TextareaWithX.vue?vue&type=template&id=4881f87e"
import script from "./TextareaWithX.vue?vue&type=script&lang=js"
export * from "./TextareaWithX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports